// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"367":"3ae1f9d7","492":"449d35ca","679":"a3d16dc7","881":"449d35ca"}[chunkId] + ".chunk.css";
};